import Backgrid from 'backgrid';
import Dotty from 'dotty';
import { html } from 'common-tags';

export default class SubCollectionCell extends Backgrid.Cell {

    className() {
        return 'sub-collection-cell';
    }

    initialize(options = {}) {
        super.initialize(options);
        if (!this.hasSubCollection()) throw new Error(`Collection is not found for path '${this.path}'`);
    }

    render() {
        this.$el.html(this.template(this.viewModel()));
        return this.delegateEvents();
    }

    viewModel() {
        return {
            view: {
                hasLabel: this.hasLabel,
                labelClassName: this.labelClassName
            },
            collection: this.getSubCollection().pluck(this.column.get('name'))
        };
    }

    template(vm) {
        const { hasLabel, labelClassName } = vm.view;
        return vm.collection.map(model => html`
            <span class="margin-small-right ${hasLabel ? 'label' : ''} ${labelClassName || ''}">
                ${model || ''}
            </span>
        `);
    }


    hasSubCollection() {
        return !! this.getSubCollection();
    }

    getSubCollection() {
        return Dotty.get(this.model, this.path);
    }

}
